import { observer } from "mobx-react-lite";
import React, { useEffect } from "react";
import { Button, Container, Typography } from "@mui/material";
import { $sidebar } from "store/sidebar";
import { useNavigate } from "react-router-dom";

const Forbidden = observer(() => {
  const navigate = useNavigate();

  useEffect(() => {
    $sidebar.setPageTitle("Нет доступа");
  }, []);

  return (
    <Container
      fixed
      sx={{
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        height: "100%",
        alignItems: "center",
        textAlign: "center",
      }}
    >
      <Typography
        component="div"
        sx={{ fontSize: "6rem", fontWeight: 600, lineHeight: 1 }}
      >
        403
      </Typography>
      <Typography variant="h4" component="div" sx={{ mt: 6, mb: 2 }}>
        Нет доступа к разделу
      </Typography>
      <Typography color="text.secondary" sx={{ mb: 4 }}>
        У вашей роли нет прав на просмотр этой страницы.
      </Typography>
      <Button variant="contained" onClick={() => navigate("/dashboard")}>
        На главную
      </Button>
    </Container>
  );
});

export default Forbidden;
